import { render, staticRenderFns } from "./FieldsRemark.vue?vue&type=template&id=5b4dd952&"
import script from "./FieldsRemark.vue?vue&type=script&lang=js&"
export * from "./FieldsRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports